import { render, staticRenderFns } from "./Modal3.vue?vue&type=template&id=31fb06e5&scoped=true&"
import script from "./Modal3.vue?vue&type=script&lang=js&"
export * from "./Modal3.vue?vue&type=script&lang=js&"
import style0 from "./Modal3.vue?vue&type=style&index=0&id=31fb06e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb06e5",
  null
  
)

export default component.exports